export const validateMinValue = (val: number, min: number) => {
  if (val < min) {
    return false;
  }
  return true;
};


